var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCaution = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.916,11.11,7.5.285a.577.577,0,0,0-1,0L.083,11.11a.588.588,0,0,0,.5.89H13.418A.588.588,0,0,0,13.916,11.11Zm-6.045-.531H6.128V8.816H7.871Zm0-2.939H6.128v-4.7H7.871Z",
  transform: "translate(0 0)",
  fill: "#eb7d3c"
})));
export default SvgIconCaution;